import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import "./App.css";

import SiteLayout from "./components/site/SiteLayout";
import Home from "./pages/Home";
import About from "./pages/About";
import Menus from "./pages/Menus";
import Catering from "./pages/Catering";
import Experiences from "./pages/Experiences";
import Corporate from "./pages/Corporate";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import QuoteBuilder from "./pages/QuoteBuilder";

import AdminLayout from "./admin/AdminLayout";
import Login from "./admin/Login";
import Dashboard from "./admin/Dashboard";
import Enquiries from "./admin/Enquiries";
import Pipeline from "./admin/Pipeline";
import MenuManager from "./admin/MenuManager";
import GenericManager from "./admin/GenericManager";
import Staff from "./admin/Staff";
import Settings from "./admin/Settings";
import AIForecast from "./admin/AIForecast";
import Activity from "./admin/Activity";
import Experience3D from "./pages/Experience3D";

function BranchesBrands() {
  return (
    <div className="space-y-10">
      <GenericManager type="branches" />
      <GenericManager type="brands" />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Suspense fallback={<div className="min-h-screen bg-velvet flex items-center justify-center text-gold">Loading experience…</div>}>
          <Routes>
            {/* Public site */}
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/menus" element={<Menus />} />
              <Route path="/catering" element={<Catering />} />
              <Route path="/experiences" element={<Experiences />} />
              <Route path="/corporate" element={<Corporate />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/quote-builder" element={<QuoteBuilder />} />
            </Route>

            {/* 3D experience (full-screen, lazy) */}
            <Route path="/experience" element={<Experience3D />} />

            {/* Admin */}
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="enquiries" element={<Enquiries />} />
              <Route path="pipeline" element={<Pipeline />} />
              <Route path="menu" element={<MenuManager />} />
              <Route path="packages" element={<GenericManager type="packages" />} />
              <Route path="gallery" element={<GenericManager type="gallery" />} />
              <Route path="bulk" element={<GenericManager type="bulk" />} />
              <Route path="testimonials" element={<GenericManager type="testimonials" />} />
              <Route path="forecast" element={<AIForecast />} />
              <Route path="staff" element={<Staff />} />
              <Route path="branches" element={<BranchesBrands />} />
              <Route path="cctv" element={<GenericManager type="cctv" />} />
              <Route path="activity" element={<Activity />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </Suspense>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}
